import React, { CSSProperties } from 'react'

interface LoaderSVGProps {
  style?: CSSProperties
  className?: string
}

const LoaderSVG = ({ style, className }: LoaderSVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="4rem"
      height="4rem"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      style={style}
      className={className}
    >
      <circle cx="50" cy="50" r="43" stroke="#21201f" strokeWidth="5" fill="none"></circle>
      <circle cx="50" cy="50" r="43" stroke="#ffa273" strokeWidth="5" strokeLinecap="round" fill="none">
        <animateTransform
          attributeName="transform"
          type="rotate"
          repeatCount="indefinite"
          dur="1.25s"
          values="0 50 50;180 50 50;720 50 50"
          keyTimes="0;0.5;1"
        ></animateTransform>
        <animate
          attributeName="stroke-dasharray"
          repeatCount="indefinite"
          dur="1.25s"
          values="0 270.1769682087222;270.1769682087222 0;0 270.1769682087222"
          keyTimes="0;0.5;1"
        ></animate>
      </circle>
    </svg>
  )
}

export default LoaderSVG
